var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36606 1.95133C7.56606 1.33733 8.43473 1.33733 8.63406 1.95133L9.64673 5.06733C9.69031 5.20099 9.77503 5.31745 9.88878 5.40007C10.0025 5.48269 10.1395 5.52723 10.2801 5.52733H13.5567C14.2027 5.52733 14.4707 6.354 13.9487 6.734L11.2981 8.65933C11.1842 8.74211 11.0995 8.8588 11.056 8.99269C11.0125 9.12658 11.0125 9.27079 11.0561 9.40467L12.0681 12.5207C12.2681 13.1353 11.5647 13.646 11.0427 13.266L8.39206 11.3407C8.27814 11.2578 8.14091 11.2132 8.00006 11.2132C7.85922 11.2132 7.72199 11.2578 7.60806 11.3407L4.9574 13.266C4.4354 13.646 3.73206 13.1347 3.93206 12.5207L4.94406 9.40467C4.98758 9.27079 4.98761 9.12658 4.94414 8.99269C4.90066 8.8588 4.81593 8.74211 4.70206 8.65933L2.0514 6.734C1.52873 6.354 1.79806 5.52733 2.4434 5.52733H5.7194C5.8601 5.52737 5.9972 5.48289 6.11108 5.40027C6.22496 5.31764 6.30978 5.2011 6.3534 5.06733L7.36606 1.95133Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/StarOutline.cec33dff8bbfd512d6d242043fc85d16.svg";
export { ForwardRef as ReactComponent };